<template>
    <div>
      <el-dialog title="定时时间" width="40%" :visible.sync="setTimeShow" :close-on-click-modal= "false" @close="closeTimeShow">
        <el-form  style="margin-left:40px;">
           <el-form-item label="设置通知时间" :label-width="formInputWidth" v-for="item in timeOptions" :key="item.index">
              <el-col :span="24">
                  <el-time-picker
                    v-model="item.value"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="任意时间点">
                  </el-time-picker>
                   <el-button
                          class="filter-item"
                          style="margin-left: 10px;"
                          type="danger"
                          @click="deleteTime(item)"
                  >删除</el-button>
              </el-col>
            </el-form-item>
              <el-button
                          class="filter-item"
                          style="margin-left: 10px;background-color:#ff9933;color:white;"
                          @click="addTime"
                  >添加</el-button>
        </el-form>
         <div slot="footer" class="dialog-footer">
            <el-button @click="removeTime">取 消</el-button>
            <el-button type="primary" @click="sureTime">确认</el-button>
         </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'setTime',
  props: {
    timeOptions: {
      type: Array
    },
    setTimeShow:{
      type: Boolean,
      default:false,
    }
  },
  data() {
    return {
        formInputWidth:"200px",
        timeShow:""
        }
  },
  created(){
  },
  methods: {
    deleteTime(item){
      this.$emit("deleteTime", item);
    },
    addTime(){
      this.$emit("addTime");
    },
    removeTime(){
      this.$emit("removeTime");
    },
    sureTime(){
      this.$emit("sureTime");
    },
    closeTimeShow(){
      this.$emit("closeTimeShow");
    },
  },
}

</script>